import React from 'react'
import { ApproveAndSendProceedingsDialog, PrimaryCta } from 'components'

/**
 * Display de total amount of the assets in the selected proceedings and gives and option to approve and send them or cancel
 * @param {object} params - The param object from the Mui DataGrid column definition
 * @returns {ReactComponentElement} - component with ammount format and button to toggle set assets dialog
 */
function GridApproveAndSendProceeding({ row }) {
  return (
    <ApproveAndSendProceedingsDialog
      togglerComponent={PrimaryCta}
      togglerProps={{ size: 'grid' }}
      proceedingsList={[row]}
    >
      Autorizar lote
    </ApproveAndSendProceedingsDialog>
  )
}

export const MemoizedGridApproveAndSendProceeding = React.memo(
  GridApproveAndSendProceeding
)
